<script setup lang="ts">
import formatBytes from "@/helpers/files/formatBytes";
import isPDFFile from "@/helpers/files/isPDFFile";
import type { IFileState } from "@/interfaces";
import { computed, toRefs } from "vue";

interface Props {
  file: IFileState;
  customStyles?: string;
}

const props = withDefaults(defineProps<Props>(), {
  customStyles: "min-w-160 w-160 h-160 min-h-160 rounded-2xl",
});
const { file } = toRefs(props);

const icon = computed(() => {
  if (file.value.type && isPDFFile(file.value.type)) {
    return "fa-file-pdf";
  }

  return "fa-file";
});
</script>

<template>
  <button
    type="button"
    class="overflow-hidden block hover:scale-105 transition-transform px-4 bg-neutral100"
    :class="[customStyles]"
    @click="$emit('click')"
  >
    <div class="flex flex-col gap-1">
      <i class="far text-3xl text-neutral1000" :class="[icon]"></i>
      <div v-if="file.name" class="b300 text-neutral1000 truncate">
        {{ file.name }}
      </div>
      <div v-if="file.size" class="b300 text-neutral700 truncate">
        {{ formatBytes(file.size) }}
      </div>
    </div>
  </button>
</template>
